<div class="header">
  <a routerLink="/" class="header__logo">
    <img
      src="assets/symbol.svg"
      height="38"
      width="38"
      alt="imagebase.pro logo"
    />
    <span>image<b>base</b></span>
  </a>
  <div class="header__search">
    <img
      src="assets/icon-search.svg"
      height="512"
      width="512"
      alt="Search icon"
    />
    <app-search-request [fc]="fc" />
  </div>

  @if (isAuthenticated$ | async) {
    <a routerLink="/account" class="header__user header__user--user-avatar">
      @let currentUserAvatar = currentUserAvatar$ | async;
      <img
        [src]="currentUserAvatar?.url || 'assets/no-avatar.svg'"
        [width]="currentUserAvatar ? currentUserAvatar.width : 100"
        [height]="currentUserAvatar ? currentUserAvatar.height : 100"
        [alt]="currentUserAvatar ? 'User avatar' : 'No avatar'"
      />
    </a>
  } @else {
    <ng-container *ngTemplateOutlet="notAuthenticated"></ng-container>
  }

  <ng-template #notAuthenticated>
    <a routerLink="/auth" class="header__user header__user--user-icon">
      <img
        src="assets/icon-user.svg"
        width="110"
        height="104"
        alt="Non-authenticated user avatar placeholder icon"
      />
    </a>
  </ng-template>
  <a
    class="header__cart"
    [class.header__cart_with-items]="hasItemsInCart$ | async"
    routerLink="/cart"
  >
    <img src="assets/icon-cart.svg" width="110" height="104" alt="Cart icon" />
  </a>
  <div class="header__menu" (click)="toggleDisplayMenu($event)">
    <div class="mobile-menu-icon"></div>
  </div>
  @if (displayMenu) {
    <app-menu (closeMenu)="onCloseMenu()" />
  }
</div>
@if (displayCategories$ | async) {
  <app-categories />
}
